import { Http } from "../utils/http.js";
class ArtistAPI extends Http {
  allArtist(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Artist/AllArtistList",
      method: "post",
      param: param
    });
  }
  artistInfo(param) {
    let _this = this;
    return _this.request({
      url: "WebApi/Artist/GetArtist",
      method: "post",
      param: param
    });
  }
}
export { ArtistAPI };
